import {createContext, useContext, useEffect} from 'react';
import {liquidGoldEligible} from './liquidGoldAccess';

export const AdminMobileFormatContext = createContext(false);
export const useAdminMobileFormat = () => useContext(AdminMobileFormatContext);
export const adminMobileFormatEnabled = ({user, narrow, requested, saved}) =>
  Boolean(narrow && liquidGoldEligible(user) && (requested === 'admin' || (requested === null && saved !== 'classic')));

// Presentation preference only. It grants no route, data or action permissions.
export function useAdminMobileFormatState(user, narrow, search) {
  const requested = new URLSearchParams(search).get('mobile_format');
  const key = `ls_mobile_format_v2:${user?.id || 'anonymous'}`;
  let saved = null;
  try { saved = sessionStorage.getItem(key); } catch (_) {}
  const enabled = adminMobileFormatEnabled({user, narrow, requested, saved});
  useEffect(() => {
    if (!liquidGoldEligible(user) || requested === null) return;
    try { sessionStorage.setItem(key, requested === 'admin' ? 'admin' : 'classic'); } catch (_) {}
  }, [user, key, requested]);
  return enabled;
}
